import { createFileRoute, redirect } from '@tanstack/react-router'
import type { LotExpiryStatus, LotStatus, LotUrlSearch } from '@/features/inventory-lots/api'
import { LotsScreen } from '@/features/inventory-lots/lots-screen'
import { hasGrant } from '@/lib/me'

const EXPIRY_STATUSES: LotExpiryStatus[] = ['healthy', 'expiring_soon', 'expired']
const LOT_STATUSES: LotStatus[] = ['active', 'expired', 'depleted', 'blocked']

function findStatus<T extends string>(statuses: readonly T[], value: unknown): T | undefined {
  if (typeof value !== 'string') return undefined
  return statuses.find((status) => status === value)
}

export const Route = createFileRoute('/_authenticated/inventory/lots/')({
  validateSearch: (search: Record<string, unknown>): LotUrlSearch => {
    const expiringWithinDays = search.expiring_within_days
    return {
      variant: typeof search.variant === 'string' && search.variant ? search.variant : undefined,
      expiry_status: findStatus(EXPIRY_STATUSES, search.expiry_status),
      status: findStatus(LOT_STATUSES, search.status),
      warehouse:
        typeof search.warehouse === 'string' && search.warehouse ? search.warehouse : undefined,
      expiring_within_days:
        typeof expiringWithinDays === 'string' || typeof expiringWithinDays === 'number'
          ? expiringWithinDays
          : undefined,
    }
  },
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'lot.view')) throw redirect({ to: '/' })
  },
  component: InventoryLotsRoute,
})

function InventoryLotsRoute() {
  return <LotsScreen search={Route.useSearch()} />
}
